export const havePermission = (user, minRole = ["all"]) => {
  if (minRole.includes(user?.permissions || []) || minRole.includes("all")) {
    return true;
  }
  return false;
};
